module.exports = __webpack_public_path__ + "static/media/2.6cea1cf7.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/beards/2.png
// module id = 1178
// module chunks = 0